module.exports = __webpack_public_path__ + "assets/00c75eb469d64a0913de7f173111895e.png";